import { FC } from "react";
import { iDataRolePermissions } from "../../../../interfaces/SuperAdmin/Pages/iDataRolePermissions";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../../../ui-components/StyledTables";
import { Checkbox } from "@mui/material";
import { useAuthContext } from "../../../../hooks/Auth";

interface Props {
  permiso: iDataRolePermissions;
  index: number;
  isSelected: boolean;
  handleSelect: (id: string) => void;
}

const RowSinglePermission: FC<Props> = ({
  permiso,
  index,
  isSelected,
  handleSelect,
}) => {
  const { canAccess } = useAuthContext();
  const isNotProfessor =
    canAccess("delete:roleApps") && canAccess("create:roleApps");
  return (
    <StyledTableRow key={permiso.id_rol_permiso_comp}>
      {isNotProfessor && (
        <StyledTableCell>
          <Checkbox
            color="primary"
            checked={isSelected}
            onChange={() => handleSelect(permiso.id_rol_permiso_comp)}
          />
        </StyledTableCell>
      )}
      <StyledTableCell>{index + 1}</StyledTableCell>
      <StyledTableCell>{permiso.componente}</StyledTableCell>
      <StyledTableCell>
        {new Date(permiso.created_at).toLocaleString()}
      </StyledTableCell>
    </StyledTableRow>
  );
};

export default RowSinglePermission;
